import Adjust from '@adjustcom/adjust-web-sdk';
import { environment } from '@env/environment';
const isProdMode = environment.production;

export const ADJUST_EVENT_TYPE = {
  TOUR_BOOKING_DETAIL: {
    label: 'Tour_booking_detail',
    sandbox: 'vnzg3c',
    live: 'a9ez43',
  },
  TOUR_CART_SELECT: {
    label: 'Tour_card_select',
    sandbox: 'v37gpp',
    live: '9j5dac',
  },
  TOUR_CHECKOUT: {
    label: 'Tour_checkout',
    sandbox: 'emap0i',
    live: '78v8wl',
  },
  TOUR_DETAIL_BOOKED: {
    label: 'Tour_detail_booked',
    sandbox: 'p4ak04',
    live: 'a21sav',
  },
  TOUR_FAVOURITE_MARK: {
    label: 'Tour_favourite_mark',
    sandbox: 'be93px',
    live: 'ilf6by',
  },
  TOUR_HOMEPAGE_VIEW: {
    label: 'Tour_homepage_view',
    sandbox: 'e9xwiz',
    live: '2n6y9l',
  },
  TOUR_INFO_CONFIRM: {
    label: 'Tour_info_confirm',
    sandbox: 'wzwqrw',
    live: 'pvokz1',
  },
  TOUR_MAPVIEW: {
    label: 'Tour_mapview',
    sandbox: 'fr15qr',
    live: 'q3e9g0',
  },
  TOUR_ORDER_TRACKING: {
    label: 'Tour_order_tracking',
    sandbox: '481b12',
    live: 'ipon84',
  },
  TOUR_ODER_TRACKING_SUCCESSFUL: {
    label: 'Tour_order_tracking_successful',
    sandbox: 'urjpxb',
    live: 'cdayes',
  },
  TOUR_PAYMENT_CANCEL: {
    label: 'Tour_payment_cancel',
    sandbox: '3k1eqm',
    live: 'san1tn',
  },
  TOUR_PAYMENT_FAILE: {
    label: 'Tour_payment_fail',
    sandbox: 'fzmm0n',
    live: 'ubvqm9',
  },
  TOUR_PAYMENT_SELECT: {
    label: 'Tour_payment_select',
    sandbox: 'ffbntq',
    live: 'd62jxz',
  },
  TOUR_PAYMENT_SUCCESS: {
    label: 'Tour_payment_success',
    sandbox: '10hq44',
    live: 'wvd2ma',
  },
  TOUR_PROMOTION_CONFIRM: {
    label: 'Tour_promotion_confirm',
    sandbox: '8lzm9u',
    live: 'psnj19',
  },
  TOUR_SEARCH: {
    label: 'Tour_search',
    sandbox: 'd3amw0',
    live: 'hg0nyb',
  },
  TOUR_TRENDING_SELECT: {
    label: 'Tour_trending_select',
    sandbox: 'qabz4h',
    live: '2juuxd',
  },
  TOUR_TRENDING_VIEWMORE: {
    label: 'Tour_trending_viewmore',
    sandbox: 'lqoqsm',
    live: '5q0rvb',
  },
  TOUR_VIEW_ALL_LIST: {
    label: 'Tour_view_all_list',
    sandbox: '2f3mxp',
    live: 'wm3flu',
  },
};

export const AdjustInstance = {
  instance: undefined as any,
  init: function () {
    if (!this.instance) {
      this.instance = Adjust;
      Adjust.initSdk({
        appToken: environment.APP_ADJUST_TOKEN || '',
        environment: isProdMode ? 'production' : 'sandbox',
        logLevel: isProdMode ? 'info' : 'verbose',
      });
    }
  },

  trackingEvent: function (eventName: string) {
    const eventData = Object.values(ADJUST_EVENT_TYPE).find((i) => i.label === eventName);
    if (!eventData?.label || !this.instance) return;

    if (eventData?.label && this.instance?.trackEvent) {
      Adjust.trackEvent({
        eventToken: isProdMode ? eventData.live : eventData.sandbox,
      });
    }
  },
  stop: function () {
    if (this.instance) Adjust.stop();
  },
};
